import React from "react";
import { Link } from "react-router-dom";
import { bool, func, string } from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Grid from "@material-ui/core/Grid";
import { Button } from "@material-ui/core";
import brandTheme from "../../../src/brandTheme/Theme";

const useStyles = makeStyles(() => ({
  mainContainer: {
    marginBottom: "17px",
    borderBottom: `1px solid ${brandTheme.mainColor}`,
    paddingBottom: "1.5%",
  },
  button: {
    backgroundColor: brandTheme.buttonColor,
    color: brandTheme.white,
    borderRadius: "10px",
    padding: "10px 15px",
    minWidth: "140px",
    textTransform:"capitalize",
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
     '@media only screen and (max-width: 600px)': {
        minWidth: "80px",
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "right",
    fontFamily: brandTheme.font.poppins,
    paddingRight: "6%",
    gap: "15px",
    "@media (max-width: 600px)": {
      justifyContent: "center",
      padding: "0px",
      marginTop:'5%'
    },
  },
  button2: {
    minWidth: "140px",
    backgroundColor: brandTheme.button2Color,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
    '@media only screen and (max-width: 600px)': {
        minWidth: "80px",
    },
  },
  button3: {
    minWidth: "140px",
    backgroundColor: brandTheme.button3Color,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
     '@media only screen and (max-width: 600px)': {
        minWidth: "80px",
    },
  },
  auctionButtonContainer:{
    padding:'2% 0 0 9%',
    justifyContent:'flex-start',
  }
}));

const BottomButton = ({
  button1,
  button2,
  button3,
  disabled1,
  disabled2,
  disabled3,
  button1click,
  button2click,
  button3click,
  auction,
  type,
}) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={12} md={12} className={classes.mainContainer}>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} className={auction ? `${classes.auctionButtonContainer} ${classes.buttonContainer}` :classes.buttonContainer}>
          {button1 && (
            <Button
              className={classes.button}
              disabled={disabled1}
              onClick={() => {
                if(type){
                  button1click(type)
                }else{
                  button1click()
                }
                }}
              id="button"
            >
              {button1}
            </Button>
          )}
          {button2 && (
            <Button
              className={`${classes.button2} ${classes.button}`}
              disabled={disabled2}
              onClick={() => button2click()}
              id="button"
            >
              {button2}
            </Button>
          )}
          {button3 && (
            <Button
              className={`${classes.button3} ${classes.button}`}
              disabled={disabled3}
              onClick={() => button3click()}
              id="button"
            >
              {button3}
            </Button>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

BottomButton.propTypes = {
  button1: string,
  button2:string,
  button3:string,
  disabled1:bool,
  disabled2:bool,
  disabled3:bool,
  button1click:func,
  button2click:func,
  button3click:func,
  auction:bool,
};
export default BottomButton;
